import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../PurchaseAccountLedgerSlice";
import {
  fetchPurchaseAccountLedger,
  fetchPurchaseAccounts,
} from "../PurchaseAccountLedgerThunk";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";

const PurchaseAccountLedgerFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters, accounts } = useSelector(
    (state) => state.purchaseAccountLedger
  );

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchPurchaseAccounts());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.accId) {
      messageApi.warning("Select Account");
      return;
    }

    dispatch(fetchPurchaseAccountLedger({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch records ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Account</label>
          <SearchListAutoComplete
            optionsList={accounts.map((c) => ({
              sale_id: c.acc_id,
              display_text: c.acc_name,
            }))}
            onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
            placeholder="Account"
            showAddNew={false}
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default PurchaseAccountLedgerFilters;
